/**
 * A simple polyfill for the native `Object.groupBy` method.
 * @src https://gist.github.com/gtrabanco/7c97bd41aa74af974fa935bfb5044b6e
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/groupBy
 */
const groupBy = (arr, callback) => {
  return arr.reduce((acc = {}, ...args) => {
    const key = callback(...args);
    acc[key] ??= [];
    acc[key].push(args[0]);
    return acc;
  }, {});
};

export default groupBy;
